// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=4a6e9caa-cbae-4f0f-a264-577e8a4a1e7c";
};